<template>
  <div>
    <div>
      <h4 class="headerWithBorder">Import Parameter Values</h4>
      <el-form :model="localValues" label-width="220px" size="mini" label-position="left">
        <el-form-item v-for="param in customParams" :key="param.name" :label="param.label || param.name">
          <div class="param-control-wrapper">
            <div v-if="param.type === 'boolean'">
              <el-switch v-model="localValues[param.name]" @change="saveCustomParamValues"></el-switch>
            </div>
            <div v-else-if="param.type === 'number'">
              <div class="el-input--mini">
                <input class="el-input__inner" style="width: 300px;" type="number" v-model.number="localValues[param.name]" @change="saveCustomParamValues" />
              </div>
            </div>
            <div v-else-if="param.type === 'select'">
              <el-select v-model="localValues[param.name]" @change="saveCustomParamValues" :placeholder="`Select ${param.name}`" style="width: 300px;">
                <el-option v-for="option in param.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input v-model="localValues[param.name]" @change="saveCustomParamValues" :placeholder="param.placeholder || `Enter ${param.name}`" style="width: 300px;"></el-input>
            </div>
            <div v-if="param.description" class="param-description">{{ param.description }}</div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomParams',
    props: {
      isModal: {
        type: Boolean,
        default: false
      },
      customParams: {
        type: Array,
        default: () => []
      },
      customParamValues: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {}
    },
    computed: {
      localValues: {
        get() {
          return this.customParamValues || {}
        },
        set(val) {
          this.$emit('update:customParamValues', val)
        }
      }
    },
    mounted() {
      this.ensureDefaults()
    },
    watch: {
      customParams: {
        handler() {
          this.ensureDefaults()
        },
        deep: true
      }
    },
    methods: {
      ensureDefaults() {
        const current = Object.assign({}, this.localValues)
        ;(this.customParams || []).forEach(p => {
          if (current[p.name] === undefined) {
            current[p.name] = p.type === 'boolean' ? !!p.defaultValue : p.defaultValue
          }
        })
        this.localValues = current
        this.$emit('save-mapping')
      },
      getParamTypeColor(type) {
        const colors = { boolean: 'success', text: 'primary', number: 'warning', select: 'info' }
        return colors[type] || 'default'
      },
      saveCustomParamValues() {
        const newValues = Object.assign({}, this.localValues)
        this.localValues = newValues
      }
    }
  }
</script>

<style scoped>
  .customParamsTable >>> table {
    table-layout: auto;
  }

  .customParamsTable >>> .VueTables__table {
    margin-top: 0;
  }

  .customParamsTable >>> .VueTables__actions {
    text-align: center;
  }

  .param-control-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .param-description {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }
</style>
